import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import AktuellesData from './Data';
import View from './View';

const TeaserEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <View {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <AktuellesData
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default TeaserEdit;
